import { useWorkerCustomToBaseQualificationNameMap } from "@src/appV2/Qualifications/useWorkerCustomToBaseQualificationNameMap";

import { useListViewOpenShiftsData } from "../../ListView/useListViewOpenShiftsData";
import { filterOpenShifts } from "../filterOpenShifts";
import { useShiftDiscoveryUserFiltersContext } from "../useUserFiltersContext";
import type { FiltersFormValues } from "./types";

export function useFilteredOpenShiftsCount(formValues: FiltersFormValues) {
  const { dates } = useShiftDiscoveryUserFiltersContext();

  const { distance, includeWindowedOutShifts, favoriteWorkplacesOnly, ...localUserFilters } =
    formValues;

  const { pay } = localUserFilters;

  const {
    shifts = [],
    offersMap,
    workplacesMap,
    isLoading,
  } = useListViewOpenShiftsData({
    distance,
    pay,
    includeWindowedOutShifts,
    favoriteWorkplacesOnly,
  });

  const customToBaseQualificationNameMap = useWorkerCustomToBaseQualificationNameMap();

  const filteredOpenShiftsData = filterOpenShifts(
    { shifts, offersMap, workplacesMap },
    { dates, ...localUserFilters },
    customToBaseQualificationNameMap
  );

  return {
    count: filteredOpenShiftsData.length,
    isLoading,
  };
}
